import { useEffect, useState } from 'react';
import axios from '../config/axios';
import { getApiUrl } from '../config/environment';
import { parseEnabledCardBrands, type ExtraCardBrand } from '../utils/cardBrands';

/** Bandeiras extras habilitadas na unidade ativa; recarrega a cada vez que `active` liga. */
export function useEnabledCardBrands(active: boolean): ExtraCardBrand[] {
  const [brands, setBrands] = useState<ExtraCardBrand[]>([]);

  useEffect(() => {
    if (!active) return;
    let cancelled = false;
    axios.get(getApiUrl('/clinic/card-fee-rates'))
      .then((res) => {
        if (!cancelled) setBrands(parseEnabledCardBrands(res.data?.data?.enabled_card_brands));
      })
      .catch(() => {
        if (!cancelled) setBrands([]);
      });
    return () => { cancelled = true; };
  }, [active]);

  return brands;
}
